import { useWebsiteSettings } from 'client/store'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LanguageSelector } from 'src/editor/shared/ui-lib/language-selector'
import { getLocalesOptions } from 'src/editor/shared/ui-lib/language-selector/utils/get-locales-options'
import {
  getWebsiteLocale,
  getWebsiteLocales,
} from 'src/editor/store/website-settings/website-settings-selector'
import { GroupTitle } from '../../settings/group-title'
import { AddWebsiteLocale } from './add-website-locale'
import { RemoveWebsiteLocale } from './remove-website-locale'

export const WebsiteLocalesSelector = () => {
  const { t } = useTranslation()

  const websiteLocale = useWebsiteSettings(getWebsiteLocale)
  const websiteLocales = useWebsiteSettings(getWebsiteLocales) || []

  const [localeToRemove, setLocaleToRemove] = useState<PageLocaleEnum | null>(
    null,
  )
  const [localeToAdd, setLocaleToAdd] = useState<PageLocaleEnum | null>(null)

  const localesOptions = useMemo(() => {
    return getLocalesOptions({
      t,
      setAdditionalProperties: locale => ({
        nonRemovable: websiteLocale === locale,
      }),
    })
  }, [t, websiteLocale])

  const handleChangeLocales = (locales: PageLocaleEnum[]) => {
    if (websiteLocales.length > locales.length) {
      const localeToRemove = websiteLocales.find(
        locale => !locales.includes(locale),
      )
      if (localeToRemove) {
        setLocaleToRemove(localeToRemove)
      }
    } else if (websiteLocales.length < locales.length) {
      const localeToAdd = locales.find(
        locale => !websiteLocales.includes(locale),
      )
      if (localeToAdd) {
        setLocaleToAdd(localeToAdd)
      }
    }
  }

  return (
    <>
      <GroupTitle withoutHorizontalLine>
        {t('website_settings.website_languages.group_title')}
      </GroupTitle>

      <LanguageSelector
        isMulti
        isLoading={!!localeToAdd}
        isDisabled={!!localeToAdd || !!localeToRemove}
        selectedLocales={websiteLocales}
        options={localesOptions}
        onChange={handleChangeLocales}
        labelText={t('website_settings.website_languages.label')}
      />
      <AddWebsiteLocale
        localeToAdd={localeToAdd}
        onFinallyAddLocale={() => setLocaleToAdd(null)}
      />
      <RemoveWebsiteLocale
        localeToRemove={localeToRemove}
        onClose={() => setLocaleToRemove(null)}
      />
    </>
  )
}
